import { useState, useEffect } from 'react';

const useTypewriter = (text, speed = 100, delay = 0, startDelay = 0) => {
    const [displayText, setDisplayText] = useState('');
    const [isDone, setIsDone] = useState(false);
    const [hasStarted, setHasStarted] = useState(false);

    useEffect(() => {
        let timer;
        let startTimer;

        const startTyping = () => {
            setHasStarted(true);
            let i = 0;
            timer = setInterval(() => {
                if (i <= text.length) {
                    setDisplayText(text.slice(0, i));
                    i++;
                } else {
                    setIsDone(true);
                    clearInterval(timer);
                }
            }, speed);
        };

        if (startDelay > 0) {
            startTimer = setTimeout(startTyping, startDelay);
        } else {
            startTyping();
        }

        return () => {
            clearInterval(timer);
            clearTimeout(startTimer);
        };
    }, [text, speed, startDelay]);

    return { displayText, isDone, hasStarted };
};

export default useTypewriter;
